export const EPaystubSnapshotReasonCode = {
  // Single-bucket changes (one primary paystub field area moved).
  EARNINGS: "earnings",
  DEDUCTIONS: "deductions",
  TAXES: "taxes",
  DISBURSEMENT: "disbursement",
  CHECK_DATE: "check_date",
  REPORTING_PERIOD: "reporting_period",
  ACCRUALS: "accruals",
  WORKER_INFO: "worker_info",
  STATE_CONFIG: "state_config",
  // Only the calculated rollups (totals/net_pay/gross_pay) moved — typically
  // an admin hand-edited a final amount without changing inputs.
  MANUAL_ADJUSTMENT: "manual_adjustment",
  // Two or more primary buckets moved in the same revision (e.g. payroll
  // re-run that touched both shifts and disbursement).
  MIXED: "mixed",
  // Patch ops landed on a path the deriver does not recognize.
  OTHER: "other",
} as const;

export type TPaystubSnapshotReasonCode =
  (typeof EPaystubSnapshotReasonCode)[keyof typeof EPaystubSnapshotReasonCode];
